import { Component, ComponentRef, Input, OnInit, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegisterComponent } from '../../components/component-lookup';
import { FlexComponent } from '../flex-component/flex.component';
import { FlexItem } from '../../../shared/services/product.service';

@RegisterComponent('FlexRow')
@Component({
  selector: 'app-flex-row',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './flex-row.component.html',
  styleUrl: './flex-row.component.scss',
  host: { class: 'flex', '[class.column-border]': 'columnBorder', '[id]': 'tourId()' }
})
export class FlexRowComponent extends FlexComponent implements OnInit {
  @Input() isRowExpanded = signal<boolean>(false);
  columnBorder = input<boolean>(false);

  override ngOnInit(): void {
    super.ngOnInit();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override onChildCreated(child: FlexItem, componentRef: ComponentRef<any>): void {
    if (child.name === 'FlexHeader') {
      componentRef.setInput('isRowExpanded', this.isRowExpanded);
      componentRef.instance.expandEvent.subscribe((expanded: boolean) => this.handleExpandEvent(expanded));
    }
  }

  protected handleExpandEvent(expanded: boolean): void {
    this.isRowExpanded.set(expanded);
  }
}
